import { Button } from "@bandit-network/react-ui-kit";
import { CheckCircledIcon, ExternalLinkIcon } from "@radix-ui/react-icons";
import React, { useCallback, useEffect, useState } from "react";
import { useQuestContext } from "../../../context/QuestContext";
import { Task, TaskType } from "../../../types";
import { getUrl } from "../../../utils";
import { useConnect } from "@bandit-network/react-wallet-kit";
import { UsersWalletAddressGithubGetAuthUrlPostRequestFromEnum } from "@bandit-network/sdk-api";
import { replaceHyperlinks } from "../../../utils/hyperlink";

export interface ConnectProps {
  data: Task;
}

const Connect: React.FC<ConnectProps> = ({ data }) => {
  const { questSDK, tasksCompleted, questId, isConnected, currentModuleId } =
    useQuestContext();
  const [redirectUrl, setRedirectUrl] = useState("");
  const { address, signature } = useConnect();

  const getAuthUrl = useCallback(async () => {
    try {
      const authUrl = await questSDK.usersWalletAddressGithubGetAuthUrlPost(
        address,
        signature.data,
        currentModuleId,
        questId,
        data,
        1,
        UsersWalletAddressGithubGetAuthUrlPostRequestFromEnum.Desktop,
      );
      setRedirectUrl(authUrl);
    } catch (e) {
      console.log("error : ", e);
    } finally {
    }
  }, [questSDK, address]);

  useEffect(() => {
    getAuthUrl();
  }, [getAuthUrl]);
  // on useEffect -> make api call, put in the state var

  // inside useCallBack, new state var
  const onClick = useCallback(async () => {
    window.open(redirectUrl);
  }, [redirectUrl]);

  const isTaskComplete = tasksCompleted.includes(data?.id);
  return (
    <div className="bad-quest__task">
      <p className="bad-quest__task--description">
        {replaceHyperlinks(data.description)}
      </p>
      <Button
        size="sm"
        className="bad-quest__task--action_button"
        onClick={onClick}
        disabled={isTaskComplete || !redirectUrl}
      >
        {isTaskComplete ? `Completed` : `Join`}
        {isTaskComplete ? (
          <CheckCircledIcon className="bad-quest__task--check_icon" />
        ) : (
          <ExternalLinkIcon className="bad-quest__task--link_icon" />
        )}
      </Button>
    </div>
  );
};

export { Connect };
